// src/components/SettingsHeader.tsx
import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

interface SettingsHeaderProps {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
}

const SettingsHeader: React.FC<SettingsHeaderProps> = ({ title, subtitle, icon }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 56,
            height: 56,
            borderRadius: 2,
            bgcolor: 'primary.main',
            color: 'primary.contrastText'
          }}
        >
          {icon}
        </Box>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            {title}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {subtitle}
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ mt: 3 }} />
    </Box>
  );
};

export default SettingsHeader;